import { FC, useState, useEffect } from 'react';

import { Game } from './components/Game';
import { Training } from './components/Training';
import type { IProduct } from '@/types/product';
import type { IGame } from '@/types/game';

const App: FC = () => {
  const [step, setStep] = useState(1);
  const [product, setProduct] = useState<IProduct>();
  // const [configId, setConfigId] = useState('');
  const [configId] = useState('');
  const [scenarios, setScenarios] = useState<IGame[]>([]);
  const [userToken, setUserToken] = useState<string>('');
  const [idGame, setIdGame] = useState<number>(0);
  const [totalPoints, setTotalPoints] = useState<number>(0);
  const [costPerQuestion, setCostPerQuestion] = useState(0);

  useEffect(() => {
    fetch(
      `https://admin.informer.jti-games.dev.familyagency.ru/api/segments/${process.env.REACT_APP_SEGMENT}/monthly-products`,
    )
      .then((response) => response.json())
      .then(({ data }) => setProduct(data));
  }, []);

  useEffect(() => {
    if (!scenarios.length && userToken) {
      fetch(
        `https://admin.informer.jti-games.dev.familyagency.ru/api/segments/${process.env.REACT_APP_SEGMENT}/games`,
        {
          headers: {
            UserToken: userToken,
          },
        },
      )
        .then((response) => response.json())
        .then(({ data }) => {
          setScenarios(data.games);
          setIdGame(data.games[0].id);
        });
    }
  }, [idGame, userToken]);

  useEffect(() => {
    window.jticonnexus.init().then((res) => {
      // setConfigId(res.config.id)
      setTotalPoints(res.config.max_points);

      setUserToken(res.user._id);

        // TEST LOG: результат выполнения метода init SDK jticonnexus при успешной инициализации
        console.log('инициализация SDK ', res)

      fetch(
        'https://admin.informer.jti-games.dev.familyagency.ru/api/custom-logs/store',
        {
          headers: {
            accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'POST',
          body: JSON.stringify({
            'token': userToken,
            'game_id': idGame,
            'question_id' : null,
            'available_score' : totalPoints,
            'awarded_score' : null,
            'action' : 'инициализация SDK',
            'result' : null,
          }),
        },
      )
    }).catch((err) => {
        // TEST LOG: результат выполнения метода init SDK jticonnexus при ошибке
        console.log('ошибка инициализация SDK ', err)
    });

    console.log('19.12.2025 13:12');
  }, []);

  useEffect(() => {
    if (scenarios.length && totalPoints) {
      const points =
        totalPoints /
        scenarios.reduce((acc, current) => {
          if (current.isScore) {
            return acc + current.questionsCount;
          }
          return acc;
        }, 0);

      setCostPerQuestion(points);

        // TEST LOG: вывод данных, которые изменяются при смене сценария
        console.log('TEST LOG: вывод данных, которые изменяются при смене сценария --- ', {
            scenarios,
            totalPoints,
            points,
            idGame,
            userToken,
        })

      fetch(
        'https://admin.informer.jti-games.dev.familyagency.ru/api/custom-logs/store',
        {
          headers: {
            accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'POST',
          body: JSON.stringify({
            'token': userToken,
            'game_id': idGame,
            'question_id' : null,
            'available_score' : points,
            'awarded_score' : null,
            'action' : 'смена сценария',
            'result' : null,
          }),
        },
      )
    }
  }, [scenarios, totalPoints]);

  return product ? (
    <>
      <Training
        step={step}
        setStep={setStep}
        product={product}
        totalPoints={totalPoints}
      />
      <Game
        step={step}
        setStep={setStep}
        product={product}
        scenarios={scenarios}
        setIdGame={setIdGame}
        idGame={idGame}
        setScenarios={setScenarios}
        configId={configId}
        userToken={userToken}
        costPerQuestion={costPerQuestion}
        totalPoints={totalPoints}
      />
    </>
  ) : null;
};

export default App;
